/**
 * Limits "The Bride" wine to maximum quantity of 1 in the bundle builder
 */

(function() {
  'use strict';

  // Configuration
  const BRIDE_PRODUCT_HANDLE = 'the-bride-2024-rose';
  const BRIDE_VARIANT_ID = '47901999890656';
  const MAX_BRIDE_QUANTITY = 1;

  /**
   * Apply quantity limit to The Bride product
   */
  function applyBrideLimits() {
    // Find The Bride product by handle
    const brideProduct = document.querySelector(`biscuits-bundle-product[data-biscuits-handle="${BRIDE_PRODUCT_HANDLE}"]`);
    
    if (!brideProduct) {
      return;
    }

    // Find the quantity component
    const quantityComponent = brideProduct.querySelector('biscuits-bundle-quantity');
    
    if (!quantityComponent) {
      return;
    }

    // Find the quantity input field
    const quantityInput = quantityComponent.querySelector(`input[id*="${BRIDE_VARIANT_ID}"]`);
    
    if (quantityInput) {
      // Set max attribute to 1
      quantityInput.setAttribute('max', MAX_BRIDE_QUANTITY);
      
      // Prevent manual input beyond limit
      quantityInput.addEventListener('input', function(e) {
        const value = parseInt(e.target.value);
        if (value > MAX_BRIDE_QUANTITY) {
          e.target.value = MAX_BRIDE_QUANTITY;
          // Trigger change event so the bundle builder updates
          e.target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      // Prevent typing beyond limit
      quantityInput.addEventListener('keydown', function(e) {
        const currentValue = parseInt(e.target.value) || 0;
        if (currentValue >= MAX_BRIDE_QUANTITY && e.key >= '0' && e.key <= '9') {
          e.preventDefault();
        }
      });
    }

    // Find plus button
    const plusButton = quantityComponent.querySelector('.biscuits-bundle-quantity__button--plus');
    
    if (plusButton) {
      // Override the plus button click
      plusButton.addEventListener('click', function(e) {
        const currentValue = parseInt(quantityInput.value) || 0;
        
        if (currentValue >= MAX_BRIDE_QUANTITY) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Disable the button visually
          plusButton.classList.add('biscuits--disabled');
          plusButton.setAttribute('disabled', 'disabled');
          
          // Show a brief message (optional)
          showLimitMessage(brideProduct);
          
          return false;
        }
      }, true); // Use capture phase to intercept before bundle's handler

      // Monitor quantity changes to disable/enable plus button
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            checkAndDisablePlusButton();
          }
        });
      });

      // Also listen to input changes
      quantityInput.addEventListener('change', checkAndDisablePlusButton);
      quantityInput.addEventListener('input', checkAndDisablePlusButton);

      function checkAndDisablePlusButton() {
        const currentValue = parseInt(quantityInput.value) || 0;
        
        if (currentValue >= MAX_BRIDE_QUANTITY) {
          plusButton.classList.add('biscuits--disabled');
          plusButton.setAttribute('disabled', 'disabled');
          plusButton.style.pointerEvents = 'none';
          plusButton.style.opacity = '0.5';
        } else {
          plusButton.classList.remove('biscuits--disabled');
          plusButton.removeAttribute('disabled');
          plusButton.style.pointerEvents = '';
          plusButton.style.opacity = '';
        }
      }

      // Observe the input value
      observer.observe(quantityInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      // Initial check
      checkAndDisablePlusButton();
    }
  }

  /**
   * Show a temporary message when limit is reached
   */
  function showLimitMessage(productElement) {
    const existingMessage = productElement.querySelector('.bride-limit-message');
    if (existingMessage) {
      return; // Message already showing
    }

    const message = document.createElement('div');
    message.className = 'bride-limit-message';
    message.style.cssText = 'color: #d9534f; font-size: 12px; margin-top: 5px; text-align: center;';
    message.textContent = 'Limit 1 per order';
    
    const detailsElement = productElement.querySelector('.biscuits-bundle-item__details');
    if (detailsElement) {
      detailsElement.appendChild(message);
      
      // Remove message after 3 seconds
      setTimeout(function() {
        if (message.parentNode) {
          message.parentNode.removeChild(message);
        }
      }, 3000);
    }
  }

  /**
   * Initialize the script
   */
  function init() {
    // Apply limits when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyBrideLimits);
    } else {
      applyBrideLimits();
    }

    // Re-apply if bundle content changes (for dynamic updates)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          applyBrideLimits();
        }
      });
    });

    // Observe the bundle step container
    const bundleContainer = document.querySelector('biscuits-bundle-step');
    if (bundleContainer) {
      observer.observe(bundleContainer, {
        childList: true,
        subtree: true
      });
    } else {
      // If container not found yet, wait a bit and try again
      setTimeout(init, 500);
    }
  }

  // Start the script
  init();
})();

